import { ROUTE_PATH, TEMPLATE_OPTIONS, statusList } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaInputModel } from "common/models/utility-models/meta-model";



export class StudentsFilterMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.branchCategory, ROUTE_PATH.branchCategoryAdd, 3);
    }
    override initProperties(): any {
        const formInfo = super.initProperties();
        const batchID = new SmMetaSelectModel(
            'batchID',
            'batchID',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            3,
            '',
            'select',
            'All Batch',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'batch_number',
            'batch_number',

        );
        const region = new SmMetaSelectModel(
            'region',
            'region',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            3,
            '',
            'select',
            'All Region',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'zone_name',
            'zone_name',

        );

        const branch_name = new SmMetaSelectModel(
            'branch_name',
            'branch_name',
            'select',
            false,
            'col-2 col-md-2',
            1,
            3,
            '',
            'select',
            'All Branch',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'department_name',
            'department_name'
        );

        const status = new SmMetaSelectModel(
            'status',
            'status',
            'select',
            false,
            'col-sm-6 col-xs-12 col-md-4 col-lg-2',
            1,
            3,
            '',
            'select',
            'All Status',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            statusList,
            'name',
            'value',


        );
        const search = new SmMetaInputModel(
            'searchText',
            'searchText',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'searchText',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );




        // const buttons = {
        //     // submit: new SmBtnMetaModel('Submit', '', true, false, false, true),
        //     isFormControl: false,
        // };


        return {
            formInfo,
            batchID,
            branch_name,
            region,
            status,
            search
        }
    }
}